import FetchService from './fetch.service';

const fetchService = new FetchService();

// In-memory (per-tab-session) cache for product settings.
// product_settings is a small, global, rarely-changing payload that gates
// feature entitlements, so it is fetched fresh on every full page reload to
// avoid stale entitlements. The module-level cache + in-flight guard only
// dedupe redundant/concurrent fetches within a single session.
let cachedProductSettings = null;
let inflightRequest = null;

class ProductSettingsService {
    async getProductSettings() {
        if (cachedProductSettings) return cachedProductSettings;

        if (!inflightRequest) {
            inflightRequest = fetchService(`/product_settings/`, {
                method: 'GET',
                cache: 'no-cache',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json',
                    "Content-Type": 'application/json',
                },
            })
                .then((response) => response.json())
                .then((resJson) => (cachedProductSettings = resJson?.product_settings))
                .finally(() => {
                    inflightRequest = null;
                });
        }

        return inflightRequest;
    }
}

export default new ProductSettingsService();
